module.exports = __webpack_public_path__ + "img/Grejanje_HEATING_GAS.b88fd99d.svg";